import { Button, Dropdown } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import { ThreeDots } from 'assets';
import { messages, organizationUnitsMessages } from 'messages';
import { OrganizationUnitDto } from 'types';

type OrganizationUnitActionProps = {
  organizationUnit: OrganizationUnitDto;
  onDelete?: (organizationUnit: OrganizationUnitDto) => void;
  onUpdateInfo?: (organizationUnit: OrganizationUnitDto) => void;
  onUpdateStaffs?: (organizationUnit: OrganizationUnitDto) => void;
};
const OrganizationUnitActions = ({
  organizationUnit,
  onDelete,
  onUpdateInfo,
  onUpdateStaffs
}: OrganizationUnitActionProps) => {
  const actionItems: ItemType[] = [
    {
      key: 'updateInfo',
      label: messages.updateInfo
    },
    {
      type: 'divider'
    },
    {
      key: 'updateStaffs',
      label: organizationUnitsMessages.updateStaffs
    },
    {
      type: 'divider'
    },
    {
      key: 'delete',
      danger: true,
      label: messages.deleteButtonText
    }
  ];

  const onClickActionItem = (action: string, data: OrganizationUnitDto) => {
    switch (action) {
      case 'delete':
        onDelete?.(data);
        break;
      case 'updateInfo':
        onUpdateInfo?.(data);
        break;
      case 'updateStaffs':
        onUpdateStaffs?.(data);
        break;
    }
  };

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{
          items: actionItems,
          onClick: ({ key }) => {
            onClickActionItem(key, organizationUnit);
          }
        }}
      >
        <Button type='text' shape='circle'>
          <ThreeDots />
        </Button>
      </Dropdown>
    </>
  );
};

export default OrganizationUnitActions;
